<template>
<div>
    <div class="contai">
        <div class="header">商城公告</div>
        <!-- <div class="text" v-for="(item,index) in list" :key="index">
            <div class="title" @click="noticedetail(item)"> {{item.title}}</div>
        </div> -->
        <van-collapse v-model="activeNames" accordion>
            <div v-for="(item,index) in list" :key="index">
                <van-collapse-item :title-class="activeNames==item.id?'blue':''" :title="item.title" :name="item.id" ><p v-html="item.context" class="phtml"></p></van-collapse-item>
            </div>
        </van-collapse>

    </div>
    <!-- <div class="paging">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" @current-change="changePage"></el-pagination>
    </div> -->
</div>
</template>

<script>
import {
    sysNotice
} from '@/api/api'
export default {
    data() {
        return {
            list: [],
            activeNames:''
        }
    },
    methods: {
        noticedetail(item) {
            this.$router.push({
                path: '/noticedetail',
                query: {
                    notice: item
                }
            })
        },
        async getNotice() {
            let params = {
                type:1
            }
            const res = await sysNotice(params);
            // console.log(res)
            if (res.code == "0000") {
                this.list = res.data.rows;
                this.activeNames=res.data.rows[0].id
            } else {
                this.$message({
                    message: "已确认收货！",
                    type: "warning"
                });
            }
        },
    },
    mounted() {
        this.getNotice()
    }
}
</script>

<style lang="scss" scoped>
.text {
    padding-top: 50px;
}
/deep/.blue{
    color:#2283e2!important
}
.contai {
    background: #fff;
    // border: 1px solid #2283e2;
    padding: 20px;
}

.header {
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #2283e2;
}

.paging {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
}

.title {
    font-size: 25px;
    cursor: pointer;
}

.title:hover {
    color: #2283e2;
}
.phtml /deep/ img{
    max-width:100%;
}
</style>
